module.exports = __webpack_public_path__ + "img/index25.066244c6.png";